import { TABS } from 'pages/CreateRubricExisting/PageProvider';
import { useTranslation } from 'react-i18next';
import { Container, Radio, RadioGroup, RichTextArea, Stack, styled, Text } from 'shell/components';
import { UploadFileForm } from 'shell/components/UploadFileDialog';
import { RUBRIC_ALLOWED_FILE_TYPES } from 'utils/constants';

const TabletForm = ({ tab, setTab, files, setFiles, error, setError, value, setValue }) => {
    const { t } = useTranslation('assignment');

    return (
        <CustomContainer device={'tablet'}>
            <RootStack alignItems={'flex-start'} spacing={5}>
                <Stack spacing={2}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('rubric.create-existing-rubric.title', 'Submit Your Rubric')}
                    </Text>
                    <Text>
                        {t(
                            'rubric.create-existing-rubric.description',
                            'Select either to upload a file or paste your text to submit your rubric.'
                        )}
                    </Text>
                </Stack>
                <CustomRadioGroup row value={tab} onChange={(e) => setTab(e.target.value)}>
                    <Radio value={TABS.FILE} label={t('upload-files.upload-file', 'Upload File')} />
                    <Radio value={TABS.TEXT} label={t('rubric.create-existing-rubric.text.title', 'Paste Text')} />
                </CustomRadioGroup>
                {tab === TABS.FILE && (
                    <Stack sx={{ width: '100%' }} spacing={5}>
                        <Stack>
                            <Text color={'light'}>
                                {t(
                                    'rubric.create-existing-rubric.file.accepted-file-types',
                                    'Only accepts files in Word, PDF or Excel (.xlsx) format.'
                                )}
                            </Text>
                            <Text color={'light'}>
                                {t(
                                    'rubric.create-existing-rubric.file.max-file-size',
                                    'Note: the maximum file size is '
                                )}
                                <Text component={'span'} weight={'medium'}>
                                    25MB
                                </Text>
                                .
                            </Text>
                        </Stack>
                        <UploadFileForm
                            allowedFileTypes={RUBRIC_ALLOWED_FILE_TYPES}
                            max={1}
                            maxFileSize={25 * 1000000} // 25MB
                            files={files}
                            setFiles={setFiles}
                            error={error}
                            setError={setError}
                        />
                    </Stack>
                )}
                {tab === TABS.TEXT && (
                    <Stack spacing={4}>
                        <Text color={'light'}>
                            {t(
                                'rubric.create-existing-rubric.text.description',
                                'To make sure TimelyGrader effectively reflects your rubric, please provide a description for each criterion, scores for all rating levels, and detailed explanations for each rating level.'
                            )}
                        </Text>
                        <CustomRichTextArea
                            placeholder={t(
                                'rubric.create-existing-rubric.text.input-placeholder',
                                'Paste your rubric here, include criteria, points, and level descriptions for the best results.'
                            )}
                            value={value}
                            onChange={(html) => setValue(html)}
                        />
                    </Stack>
                )}
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        paddingBottom: theme.spacing(10),
        background: theme.palette.ensightful.shades[0],
    };
});

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const CustomRadioGroup = styled(RadioGroup)(({ theme }) => ({
    gap: theme.spacing(8),
}));

const CustomRichTextArea = styled(RichTextArea)(() => {
    return {
        '& > .MuiRichTextArea-root': {
            minHeight: '20rem',
            maxHeight: '20rem',
        },
    };
});

export default TabletForm;
